var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindowsFill = function SvgWindowsFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.9 3.9h16.2a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9H3.9a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9m15.3 6.3H4.8v8.1h14.4zM5.7 6.6v1.8h1.8V6.6zm3.6 0v1.8h1.8V6.6z"
  })));
};
export default SvgWindowsFill;